module.exports = __webpack_public_path__ + "img/logo.ad733786.png";